import { StyledModal } from '@app/components/modal/Modal';
import type { Brand } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import useUserActions from '@app/hooks/users/useUserActions';

export type BrandDeleteModalProps = ModalProps & {
    title?: string;
    data?: Brand;
};

export const BrandDeleteModal = ({
    title = 'Delete Brand?',
    data,
    ...props
}: BrandDeleteModalProps) => {
    const { deleteUser } = useUserActions();

    return (
        <StyledModal
            title={title}
            maskClosable={false}
            okText="Delete"
            {...props}
            confirmLoading={deleteUser?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteUser.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this brand?</p>
        </StyledModal>
    );
};

export default BrandDeleteModal;
